<template>
    <div class="modal-card pop_min" id="draggable" style="overflow-y:hidden">
        <header class="modal-card-head pop-header">
            <p class="modal-card-title tit">
                {{ title }}
                <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            </p>
        </header>
        <section class="modal-card-body pop-content">
            <div class="inner-box">
                <div class="table-b" style="margin-bottom: 10px">
                    <div>
                        <div class="btn-wrap btn-type1 clearfix">
                            <button class="btn-size btn-blue fl_right" @click="insert">
                                <span class="btn-icon"><i class="fas fa-check"></i></span> 저장
                            </button>
                        </div>
                    </div>
                    <div class="inner-box" style="height: 210px">
                        <div class="table-area">
                            <div class="table-a">
                                <table id="basic" class="table">
                                    <colgroup>
                                        <col width="15%">
                                        <col width="35%">
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                      <th class="tp-a">이름</th>
                                      <td>
                                        <div class="td-s-thumb search-area" style="width: 200px">
                                          <input class="input" type="text" v-model="form.visitorNm"/>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th class="tp-a">생년월일</th>
                                      <td>
                                        <div class="td-s-thumb search-area" style="width: 200px">
                                          <input class="input" type="text" v-model="form.visitorBirth" maxlength="10" placeholder="1989-01-22"/>
                                        </div>
                                      </td>
                                    </tr>
                                    <tr>
                                      <th class="tp-a">전화번호</th>
                                      <td>
                                        <div class="td-s-thumb search-area" style="width: 200px">
                                          <input class="input" type="text" v-model="form.visitorMobile" maxlength="13" placeholder="010-1234-5678"/>
                                        </div>
                                      </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Layout from '@/components/ModalSlot.vue'
    import mixin from '@/mixin'
    import mixinSlip from '@/mixin/slip'
    import _ from "lodash"

    export default {
        name: 'VisitDetailAdd',
        props: {
          compCd: {
            type: String,
            required: false
          },
          visitNo: {
            type: String,
            require: false
          },
          visitorList: {
            type: Array,
            require: false
          }
        },
        mixins: [mixin, mixinSlip],
        components: {Layout},
        data() {
            return {
                title: '방문인원 추가',
                form: {
                    compCd: '',
                    visitNo: '',
                    visitorNm: '',
                    visitorBirth: '',
                    visitorMobile: '',
                },
                returnObject: {},
            }
        },
        methods: {
            insert() {
                if (!this.validation()) return

                this.$swal({
                    type: 'warning',
                    text: `방문인원을 추가합니다. 계속 하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        const param = JSON.parse(JSON.stringify(this.form))
                        const stripFields = ['visitorMobile', 'visitorBirth']
                        _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]))

                        this.$http.post(`/api/visit/save/visitor/add`, param
                        ).then((response) => {
                            this.$swal({type: 'info', text: '저장되었습니다.'})
                        }).catch((e) => {
                            console.error(e)
                        }).finally(()=>{
                            this.$parent.close()
                            //this.$parent.$parent.$parent.getVisit()
                            this.$emit('close', this.form.visitNo)
                        })
                    }
                })
            },
            doReturnObject(rId) {
                this.returnObject.name = ''
                this.$parent.$emit('receive', this.returnObject)
                this.closeModal()
            },
            closeModal() {
                this.$parent.close()
            },
            async validation() {
              const visitorInfo = JSON.parse(JSON.stringify(this.form))
              const stripFields = ['visitorMobile', 'visitorBirth']
              _.forEach(stripFields, (name) => visitorInfo[name] = this.toPure(visitorInfo[name]))

              if (!visitorInfo.visitorNm) {
                this.$swal({type: 'warning', text: '이름을 입력해 주세요.'})
                return false
              }
              if (!visitorInfo.visitorBirth) {
                this.$swal({type: 'warning', text: '생년월일을 입력해 주세요.'})
                return false
              }
              if (!visitorInfo.visitorMobile) {
                this.$swal({type: 'warning', text: '전화번호를 입력해 주세요.'})
                return false
              }

              let valid = true

              let work = _.forEach(this.visitorList, v => {
                if(this.toPure(v.visitorMobile) === this.toPure(this.form.visitorMobile)){
                  this.$swal({type: 'warning', text: '전화번호가 같은 인원이 존재합니다.'})
                  valid = false
                }
              })

              Promise.all(work)
                  .then(response => {
                    if(valid === false) {
                      this.$swal({type: 'warning', text: '전화번호가 같은 인원이 존재합니다.'})
                      return false
                    } else {
                      return true
                    }
                  })

            },
        },
        mounted() {
          //pop slots modal move
          $(".animation-content").addClass('pop_min')
          $(".animation-content").draggable()
          //ModalSlot open z-index change
          $('.lnb').css('z-index', '4')

          this.form.compCd = this.compCd
          this.form.visitNo = this.visitNo
        },
        watch: {
            'form.visitorMobile': {
                deep: true,
                handler(value) {
                    let val = value.replace(/-/g, '').replace(/[^0-9]/g, '')
                    let len = val.length
                    if (len == 11) {
                        this.form.visitorMobile = val.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
                    } else if (len == 8) {
                        this.form.visitorMobile = val.replace(/(\d{4})(\d{4})/, '$1-$2')
                    } else if (len == 9) {
                        this.form.visitorMobile = val.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
                    } else {
                        if (val.indexOf('02') == 0) {
                            this.form.visitorMobile = val.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
                        } else {
                            this.form.visitorMobile = val.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
                        }
                    }
                }
            },
            'form.visitorBirth': {
                deep: true,
                handler(value) {
                    let val = value.replace(/-/g, '').replace(/[^0-9]/g, '')
                    this.form.visitorBirth = val.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
                }
            }
        }
    }
</script>

<style scoped>
    div#gridbox {
        width: 100%;
        height: 100%;
        min-height: 300px;
    }

    .desc-content:after {
        clear: both;
        content: '';
        display: block;
    }

    .btn-wrap {
        margin-bottom: 20px;
    }

    .desc-content {
        border: 2px solid #9db6c9;
        background: #f9fafc;
        margin: 0 0 20px 0;
        border-radius: 4px;
        padding: 15px 2%;
        clear: both;
    }

    .desc-content .item {
        float: left;
    }

    .desc-content .item .desc-item {
        position: relative;
        padding-left: 82px;
        margin-bottom: 8px;
    }

    .desc-content .item .desc-item:last-child {
        margin-bottom: 0;
        height: 25px;
    }

    .desc-content .item .desc-item .tit {
        position: absolute;
        left: 0;
    }

    .desc-content .item .desc-item .label-tit {
        font-family: 'NotoM';
        color: #222;
        font-size: 15px;
    }

    .desc-content .item.desc-left .desc-item {
        padding-left: 90px;
    }

    .desc-content .item.desc-left .desc-item .desc:after {
        clear: both;
        content: '';
        display: block;
    }

    .desc-content .item.desc-left .desc-item .desc .datepicker {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc span.wave {
        float: left;
        padding: 0 6px;
    }

    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
        clear: both;
        content: '';
        display: block;
    }

    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc.select select {
        width: 70%;
    }

    .desc-content .item.desc-left {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-center {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-right {
        width: 30%;
    }

    .search-area input {
        position: relative;
    }

    .search-area .icon {
        position: absolute;
        right: 8px;
        top: 1px;
        z-index: 100;
        cursor: pointer;
        font-size: 16px;
        color: #555;
    }

    .search-border .td-s-thumb {
        position: relative;
        display: inline-block;
    }

    .search-border .td-s-thumb.search-area > input,
    .search-border .td-s-thumb.search-area > .ip-box
    .search-border .td-s-thumb.search-area > button {
        float: left;
    }

    .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
        width: 60%;
        margin-left: 6px;
    }

    .remove_text {
        margin-left: 0;
    }

    .contents div.gridbox_material.gridbox .xhdr {
        border-bottom: 1px solid #dfdfdf;
    }

    @media (max-width: 1580px) {
        .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
            width: 50%;
        }
    }

    .modal-card {
        width: auto;
    }

    .tp-a {
        padding-left: 23px;
    }
    .tp-c {
        padding-left: 23px;
    }

    .table-area .table-a table th.tp-a:before {
        content: '*';
        color: #f04f2f;
        position: absolute;
        left: 11px;
        top: 16px;
    }
</style>
